import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
// import cloneDeep from 'lodash/cloneDeep';
// import isEqual from 'lodash/isEqual';
import cronTaskController from './controller';
import {
  CronTaskItem,
  CronTaskRunHistoryItem,
} from '../api/cronTask';

export interface CronTaskStore {
  cronTaskList: CronTaskItem[],
  cronTaskRunHistoryIList: CronTaskRunHistoryItem[],
  cronTaskRunHistoryIListByCronTaskId: number,

  error: ErrorInterface,
}

const initialValues: CronTaskStore = {
  cronTaskList: [],
  cronTaskRunHistoryIList: [],
  cronTaskRunHistoryIListByCronTaskId: null,

  error: null,
};

export const cronTaskStore = observable(initialValues);

export const cronTaskActions = {

  async getCronTaskList() {
    cronTaskActions.clearError();
    const response = await cronTaskController.getCronTaskList();
    cronTaskActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cronTaskStore.cronTaskList = response.data?.items ?? [];
      }
    });
  },

  async getCronTaskRunHistory(cronTaskId:number) {
    cronTaskActions.clearError();
    runInAction(() => {
      cronTaskStore.cronTaskRunHistoryIListByCronTaskId = cronTaskId;
    });
    const response = await cronTaskController.getCronTaskRunHistory(cronTaskId);
    cronTaskActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        cronTaskStore.cronTaskRunHistoryIList = response.data?.items ?? [];
      } else {
        cronTaskActions.clearCronTaskRunHistoryIList();
      }
    });
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      cronTaskStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
      };
      // schedulerReferenceStore.loading = false;
      throw errorData;
    }
  }),

  clearCronTaskRunHistoryIList: action(() => {
    cronTaskStore.cronTaskRunHistoryIListByCronTaskId = null;
    cronTaskStore.cronTaskRunHistoryIList = [];
  }),

  async clearError() {
    cronTaskStore.error = null;
  },

};
